import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
  position: 'relative',
  top: '-19px',
  padding: theme.margin.small,
});

const Content = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

Content.propTypes = {
  children: PropTypes.node,
};

export default React.memo(Content);
